/** @warning should be used only within in the feature-flag package */
const windowFF = window;
export const getGlobalFeatureFlags = () => {
    return windowFF.ff;
};
